module.exports = __webpack_public_path__ + "fonts/opensans-extrabolditalic.db32de24.ttf";